<template>
  <ScreenAdapter>
    <div class="screen-container">
      <!-- 标题区域 -->
      <header class="header">
        <div class="datetime-container">
          <div class="date">{{ currentDate }}</div>
          <div class="time">{{ currentTime }}&nbsp;&nbsp;{{ currentWeekDay }}</div>
        </div>
        <h1 class="title">上电智联人工智能赋能制造业场景解决方案</h1>
      </header>

      <!-- 主内容区域 -->
      <main class="main-content">
        <!-- 左侧大图区域 -->
        <section class="left-section">
          <div class="big-image-placeholder">
            <div class="placeholder-content">
              <img src="@/assets/images/ai/main.png" alt="" />
              <a
                href="https://evaluation.sdznzz.com/"
                target="_blank"
                class="btn"
              ></a>
            </div>
          </div>
        </section>

        <!-- 右侧内容区域 -->
        <section class="right-section">
          <!-- 先进级应用标签 -->
          <div class="section-label-container">
            <div class="section-label advanced-label">先进级应用</div>
          </div>
          <div class="modules">
            <!-- 认知和推理模块 -->
            <div class="module">
              <h2 class="module-title">认知和推理</h2>
              <div class="image-grid">
                <div class="image-item" @click="openVideoModal('01.mp4')">
                  <div class="image-placeholder">
                    <div>智能设备</div>
                    <div>预测性维护</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('02.mp4')">
                  <div class="image-placeholder">
                    <div>生产调度</div>
                    <div>动态优化</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('03.mp4')">
                  <div class="image-placeholder">
                    <div>质量缺陷</div>
                    <div>根因追溯</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('04.mp4')">
                  <div class="image-placeholder">
                    <div>工艺参数</div>
                    <div>智能调优</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 人工智能代理模块 -->
            <div class="module">
              <h2 class="module-title">人工智能代理 (AI Agent)</h2>
              <div class="image-grid">
                <div class="image-item" @click="openVideoModal('05.mp4')">
                  <div class="image-placeholder">
                    <div>智能生产调度优化</div>
                    <div>AI Agent</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('06.mp4')">
                  <div class="image-placeholder">
                    <div>预测性设备维护</div>
                    <div>AI Agent</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('07.mp4')">
                  <div class="image-placeholder">
                    <div>供应链协同优化</div>
                    <div>AI Agent</div>
                  </div>
                </div>
                <div class="image-item" @click="openVideoModal('08.mp4')">
                  <div class="image-placeholder">
                    <div>质量检测自动化</div>
                    <div>AI Agent</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <div class="middle-line"></div>
      <!-- 底部内容区域 -->
      <footer class="footer-section">
        <!-- 基础级应用标签 -->
        <div class="vertical-label">基础级应用</div>

        <!-- 底部三个模块 -->
        <div class="footer-grid">
          <!-- 传统机器学习 -->
          <div class="footer-module">
            <h2 class="module-title">传统机器学习</h2>
            <div class="image-item-large" @click="openVideoModal('09.mp4')">
              <div class="image-placeholder">
                <div>生产设备智能监测</div>
              </div>
            </div>
          </div>

          <!-- 机器视觉与机器感知 -->
          <div class="footer-module">
            <h2 class="module-title">机器视觉与机器感知</h2>
            <div class="image-item-large" @click="openVideoModal('10.mp4')">
              <div class="image-placeholder">
                <div>智能质检</div>
                <div>机械臂智能控制</div>
                <div>AGV自动导航</div>
              </div>
            </div>
          </div>

          <!-- 生成式人工智能 -->
          <div class="footer-module">
            <h2 class="module-title">生成式人工智能</h2>
            <div class="image-item-large" @click="openVideoModal('11.mp4')">
              <div class="image-placeholder">
                <div>创新设计与工艺优化</div>
                <div>模拟仿真与机器人训练</div>
                <div>知识管理与决策支持</div>
              </div>
            </div>
          </div>
        </div>
      </footer>
<!-- 视频弹窗 -->
        <div v-if="showVideoModal" class="video-modal" @click="closeVideoModal">
          <div class="video-container" @click.stop>
            <button class="close-btn" @click="closeVideoModal">×</button>
            <video 
              ref="videoPlayer" 
              class="video-player" 
              controls 
              @loadeddata="onVideoLoaded"
              @error="onVideoError"
            >
              <source :src="videoSrc" type="video/mp4">
              您的浏览器不支持HTML5视频播放
            </video>
            <div v-if="videoLoading" class="loading-overlay">
              <div class="loading-spinner"></div>
              <div class="loading-text">视频加载中...</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ScreenAdapter>
</template>

<script>
import dayjs from "dayjs";
import ScreenAdapter from "../components/ScreenAdapter.vue";
export default {
  name: "screenAi",
  components: {
    ScreenAdapter,
  },
  data() {
    return {
      showVideoModal: false,
      videoLoading: false,
      videoSrc: '',
      currentDate: '',
      currentTime: '',
      currentWeekDay: '',
      timer: null,
    };
  },
  mounted() {
    this.updateDateTime();
    this.timer = setInterval(() => {
      this.updateDateTime();
    }, 1000);
  },
  beforeMount() {
    document.documentElement.webkitRequestFullScreen();
  },
  beforeDestroy() {
    this.closeVideoModal();
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    openVideoModal(videoFileName) {
      this.videoSrc = require('../assets/videos/' + videoFileName);
      this.showVideoModal = true;
      this.videoLoading = true;
      this.$nextTick(() => {
        const video = this.$refs.videoPlayer;
        if (video) {
          video.load();
          video.play().then(() => {
            console.log('视频播放成功:', videoFileName);
          }).catch(err => {
            console.log('自动播放被阻止，需要用户交互:', err);
          });
        }
      });
    },
    closeVideoModal() {
      this.showVideoModal = false;
      this.videoLoading = false;
      const video = this.$refs.videoPlayer;
      if (video) {
        video.pause();
        video.currentTime = 0;
      }
    },
    updateDateTime() {
      const now = dayjs();
      this.currentDate = now.format('YYYY年MM月DD日');
      this.currentTime = now.format('HH:mm:ss');
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      this.currentWeekDay = weekDays[now.day()];
    },
    onVideoLoaded() {
      this.videoLoading = false;
    },
    onVideoError(event) {
      this.videoLoading = false;
      console.error('视频加载失败:', event);
      alert('视频加载失败，请检查视频文件是否存在');
    },
  },
};

// 组件逻辑
</script>

<style scoped lang="less">
.screen-container {
  width: 1920px;
  height: 1080px;
  display: flex;
  flex-direction: column;
  background-color: #021630;
  overflow: hidden;
  padding: 10px 20px 20px;
  box-sizing: border-box;
  background-image: url(../assets/images/ys/bg.png);
  background-size: 101% 100%;
  background-repeat: no-repeat;
}

.header {
  text-align: center;
  padding: 0 0 32px;
  flex-shrink: 0;
  position: relative;
}

.datetime-container {
  position: absolute;
  top: 30px;
  right: 30px;
  text-align: right;
  color: #fff;
}

.date {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 3px;
}

.time {
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 3px;
}

.title {
  font-size: 32px;
  font-weight: bold;
  color: #ffffff;
  margin: 0;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
  letter-spacing: 2px;
}

.main-content {
  display: flex;
}

.left-section {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 610px;
  height: 620px;
}

.big-image-placeholder {
  width: 610px;
  height: 620px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  div {
    color: yellow;
    font-weight: bold;
  }
}

.placeholder-content {
  text-align: center;
  position: relative;
  img {
    width: 610px;
    height: 620px;
  }
  .btn {
    position: absolute;
    width: 200px;
    height: 50px;
    cursor: pointer;
    left: 250px;
    top: 290px;
  }
}

.placeholder-text {
  font-size: 20px;
  color: rgba(255, 255, 255, 0.4);
}

.right-section {
  position: relative;
  padding: 20px 0 0 0;
  height: 620px;
}
.section-label-container {
  width: 100%;
  display: flex;
  justify-content: center;
}
.section-label {
  padding: 15px 60px 15px 68px;
  border-radius: 4px;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  color: white;
  flex-shrink: 0;
  letter-spacing: 4px;
}

.advanced-label {
  background: linear-gradient(135deg, #3949ab 0%, #5c6bc0 100%);
  align-self: flex-end;
}
.modules {
  display: flex;
  margin-top: 20px;
}
.module {
  width: 50%;
  height: 540px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
}

.module-title {
  font-size: 18px;
  color: #ffffff;
  margin: 16px;
  font-weight: 600;
}

.image-grid {
  display: flex;
  flex-wrap: wrap;
}

.two-col {
  grid-template-columns: repeat(2, 1fr);
}

.image-item {
  min-height: 0;
  width: 270px;
  height: 200px;
  margin: 20px;
  cursor: pointer;
  background-image: url(../assets/images/ai/itembg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.image-item-large {
  min-height: 0;
  width: 400px;
  height: 220px;
  cursor: pointer;
  background-image: url(../assets/images/ai/itembg.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.image-placeholder {
  width: 100%;
  height: 100%;
  min-height: 80px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
  div {
    color: yellow;
    font-size: 21px;
    font-weight: bold;
    line-height: 1.8;
    letter-spacing: 3px;
  }
}

.image-placeholder span {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  word-break: break-all;
}

.footer-section {
  display: flex;
  margin-top: 16px;
  flex-shrink: 0;
  padding: 0 40px;
}

.vertical-label {
  writing-mode: vertical-rl;
  text-orientation: mixed;
  padding: 20px 15px;
  background: linear-gradient(180deg, #3949ab 0%, #5c6bc0 100%);
  border-radius: 4px;
  font-weight: bold;
  font-size: 16px;
  color: white;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  letter-spacing: 5px;
}

.footer-grid {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.footer-module {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.middle-line {
  height: 3px;
  border: 1px solid #2e54a1;
  flex-shrink: 0;
  background-color: #fff;
  width: 100%;
  margin: 10px 0;
}

/* 视频弹窗样式 */
.video-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.video-container {
  position: relative;
  width: 1280px;
  height: 720px;
}

.video-player {
  width: 100%;
  height: 100%;
  background: #000;
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.loading-text {
  color: #fff;
  margin-top: 16px;
  font-size: 16px;
}
</style>
